import { contrastColor, LXB_COLOR } from 'grosella/utils'
import React, { h } from 'preact'

import style from './button.css'

interface Props {
    onClick?: (event: any) => void
    backgroundColor?: string
    disabled?: boolean
}

export const Button: React.FunctionalComponent<Props> = ({
    onClick,
    children,
    backgroundColor,
    disabled,
    ...rest
}) => {
    const safeBackgroundColor = backgroundColor || LXB_COLOR

    const classes = [style['mdc-button'], style['mdc-button--raised']].filter(
        Boolean
    ) as string[]
    return (
        <button
            className={classes.join(' ')}
            disabled={disabled}
            {...rest}
            onClick={onClick}
            style={{
                letterSpacing: '1px',
                padding: '8px',
                fontFamily: 'Helvetica',
                borderRadius: '6px',
                backgroundColor: safeBackgroundColor,
                color: contrastColor(safeBackgroundColor),
            }}
        >
            {children}
        </button>
    )
}
